import { generateDeleteActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readFee: generateReadOneActionCreator(routes.API_PRODUCT_FEES, ACTION_NAMES.PRODUCT_FEES),
    updateFee: generateUpdateActionCreator(routes.API_PRODUCT_FEES, ACTION_NAMES.PRODUCT_FEES),
    deleteFee: generateDeleteActionCreator(routes.API_PRODUCT_FEES, ACTION_NAMES.PRODUCT_FEES)
}
